import moniveaRoadLogo from '../assets/images/moniveaRoadLogo.png';
import patient from '../assets/icons/patient.png';
import newUser from '../assets/icons/patient-new.png';
import heydayLogo from '../assets/images/heyday-logo.svg';
import medreleafLogo from '../assets/images/medreleaf-logo.png';
import { WelcomeBanner } from './WelcomeBanner';
import isMobile from 'ismobilejs';
import { useEffect, useState } from 'react';

const Login = () => {
  const cards = [
    {
      image: patient,
      title: 'Patient Login',
      description: 'Login to resume your medication journey',
      linkName: 'Login to the portal',
      onClick: () => window.location.replace('/home'),
    },
    {
      image: newUser,
      title: 'Guest Shopping',
      description: 'Explore our non-prescription product range',
      linkName: 'Browse as guest',
      onClick: () => window.location.replace('/guest/shop'),
    },
  ];

  const [hideBanner, setHideBanner] = useState(false);

  useEffect(() => {
    localStorage.removeItem('hideBanner');
    const bannerState = localStorage.getItem('hideBanner');
    if (bannerState) {
      setHideBanner(JSON.parse(bannerState));
    }
  }, []);

  const handleBannerClose = () => {
    setHideBanner(true);
    localStorage.setItem('hideBanner', JSON.stringify(true));
  };

  return (
    <div
      className={`bg-body-pattern bg-no-repeat bg-100 overflow-y-auto xs:pb-10
        lg:pb-0 h-lvh mt-0 ${process.env.VITE_THEME_TOGGLE === 'MedReleaf' ? 'bg-grey-25' : 'bg-white'}`}
    >
      <div className="w-full px-6 md:px-16 lg:px-0 mx-auto h-full flex flex-col items-center justify-center">
        <div className="bg-white pb-10 shadow md:shadow-3xl rounded-lg">
          <div
            className={`flex justify-center items-center 
              p-8 rounded-t-lg ${process.env.VITE_THEME_TOGGLE === 'MedReleaf' ? 'bg-white' : 'bg-primary-blue-500'}`}
          >
            <img
              className="w-80"
              src={
                process.env.VITE_THEME_TOGGLE === 'HeyDay'
                  ? heydayLogo
                  : process.env.VITE_THEME_TOGGLE === 'MedReleaf'
                    ? medreleafLogo
                    : moniveaRoadLogo
              }
              alt="Monivea Road logo"
            />
          </div>{' '}
          <div className="p-3 lg:px-10">
            <p className="text-primary-blue-500 text-base font-semibold mt-4">
              Welcome to our brand new Portal! Here you can{' '}
              <span className="text-secondary-pink-500">
                manage, order and refill
              </span>{' '}
              your prescriptions.
            </p>
            {isMobile()?.phone ? (
              <></>
            ) : (
              <p className="text-sm font-regular text-primary-blue-500 mt-6 md:mt-12">
                Please help us in identifying you.
              </p>
            )}
            <div className="flex flex-col md:flex-row justify-center items-stretch mt-3 -mx-3">
              {cards.map((c, i) => (
                <a
                  key={i}
                  className={`md:w-1/2 lg:w-unset lg:max-w-sm p-6 mx-3 rounded-lg cursor-pointer  mb-4 md:mb-0 shadow-3xl md:shadow-none
                ${process.env.VITE_THEME_TOGGLE === 'MedReleaf' ? 'border bg-secondary-pink-600' : 'bg-secondary-pink-100'} 
                ${c.title === 'New Patient' && process.env.VITE_THEME_TOGGLE === 'MedReleaf' ? 'medreleaf-grey-card' : ''}`}
                  onClick={() => c.onClick()}
                >
                  <img
                    className="w-10 md:w-12 mb-3.5 md:mb-7"
                    src={
                      process.env.VITE_THEME_TOGGLE === 'HeyDay'
                        ? ''
                        : process.env.VITE_THEME_TOGGLE === 'MedReleaf'
                          ? ''
                          : c.image
                    }
                  />
                  <h5
                    className={`mb-1 text-xl md:text-2xl font-semibold 
                    ${process.env.VITE_THEME_TOGGLE === 'MedReleaf' ? 'text-black' : 'text-primary-blue-500'}`}
                  >
                    {c.title}
                  </h5>
                  <p className="md:mb-3 text-sm md:text-base text-primary-blue-500 font-light">
                    {c.description}
                  </p>
                </a>
              ))}
            </div>
            <div className="flex justify-center text-sm font-semibold text-primary-blue-500 mt-1 md:mt-12">
              <p
                onClick={() => window.location.replace('/reset-password-mail')}
                className={`${isMobile()?.phone ? '' : 'border-r border-primary-blue-500 pr-4'} cursor-pointer`}
              >
                Forgot Password
              </p>
              {!isMobile().phone ? (
                <p
                  onClick={() =>
                    (window.location.href =
                      'https://monivearoad.com.au/contact-us/')
                  }
                  className="ml-4 cursor-pointer"
                >
                  Contact Us
                </p>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
      {process.env.VITE_SHOW_BANNER === 'TRUE' && !isMobile()?.phone && (
        <WelcomeBanner
          hideBanner={hideBanner}
          handleBannerClose={handleBannerClose}
          className="fixed top-0"
        />
      )}
    </div>
  );
};

export default Login;
